module.exports = __webpack_public_path__ + "static/media/jon.351f1cc0.png";